import React, { Component } from "react";
import styles from "./dropdown.module.css";
import { Select, MenuItem } from "@material-ui/core";
import classnames from "classnames";
import { ReactComponent as ExpandIcon } from "src/icons/expand_more_white_24dp.svg";
import { Options } from "src/model/myTypes";

type Props = {
  classname?: string;
  name?: string;
  options: Options;
  value: string;
  label?: string;
  handleOnChange: Function;
};

class Dropdown extends Component<Props> {
  handleOnChange = (newValue: string) => {
    if (typeof this.props.name !== "undefined") {
      this.props.handleOnChange(this.props.name, newValue);
    } else {
      this.props.handleOnChange(newValue);
    }
  };

  renderOptions() {
    return Object.keys(this.props.options).map((value, index) => (
      <MenuItem
        key={value + "_" + index}
        classes={{ root: styles.option }}
        value={value}
      >
        {this.props.options[value]}
      </MenuItem>
    ));
  }

  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        {typeof this.props.label !== "undefined" && (
          <span className={styles.label}>{this.props.label}</span>
        )}
        <label className={styles.inputWrapper}>
          <Select
            classes={{
              root: styles.select,
              icon: styles.icon,
            }}
            className={styles.selectWrapper}
            value={this.props.value}
            onChange={(e) => this.handleOnChange(e.target.value as string)}
            MenuProps={{ classes: { list: styles.list } }}
            disableUnderline
            IconComponent={ExpandIcon}
          >
            {this.renderOptions()}
          </Select>
        </label>
      </div>
    );
  }
}

export default Dropdown;
